import { apiAuth, apiResponseType } from ".";

export const getFinancialTransactionsData = (
  page: number = 1,
  filters = {}
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, value.toString());
    }
  });

  return apiAuth.get(`financial-transactions?${queryParams.toString()}`);
};

export const searchFinancialTransactionsData = (params: {
  description?: string;
  amount?: string | number;
  unity_id?: string | number;
  expense_id?: string | number;
  revenue_id?: string | number;
  date_start_payment?: string;
  date_end_payment?: string;
  date_start?: string;
  page?: number;
  date_end?: string;
  transaction_type_id?: string | number;
  status_id?: string | number;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  
  // Adiciona os parâmetros à query string se existirem
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value.toString());
    }
  });
  
  return apiAuth.get(`financial-transactions?${queryParams.toString()}`);
};

export const storeFinancialTransactionData = (data: {
  description: string;
  amount: number;
  unity_id: number;
  expense_type_id?: number | undefined;
  due_date: string;
  default_due_date?: string;
  recurrence_period_type_id?: number;
  payment_date?: string;
  observation?: string;
  financial_transaction_type_id: number;
  financial_transaction_status_id: number;
}) => apiAuth.post("financial-transactions/store", data) as apiResponseType;

export const updateFinancialTransactionData = (
  uuid: string,
  data
) =>
  apiAuth.post(`financial-transactions/${uuid}/update`, data) as apiResponseType;

export const updateFinancialTransactionStatus = (
  uuid: string,
  data
) =>
  apiAuth.put(`financial-transactions/${uuid}/update-status`, data) as apiResponseType;

export const deleteFinancialTransactionData = (uuid: string) =>
  apiAuth.delete(`financial-transactions/${uuid}/destroy`) as apiResponseType;

export const deleteMultipleFinancialTransactions = async (uuids: string[]) => {
  const promises = uuids.map(uuid => 
    apiAuth.delete(`financial-transactions/${uuid}/destroy`)
  );
  return Promise.all(promises);
};

export const toggleFinancialTransactionStatus = (uuid: string) =>
  apiAuth.put(
    `financial-transactions/${uuid}/toggle-status`
  ) as apiResponseType;

export const getShowFinancialTransaction = (uuid: string) =>
  apiAuth.get(`financial-transactions/${uuid}/show`) as apiResponseType;

// Attachment endpoints
export const getFinancialTransactionAttachments = (uuid: string) =>
  apiAuth.get(`financial-transactions/${uuid}/attachments`) as apiResponseType;

export const getFinancialTransactionAttachmentShow = (id: number | string) =>
  apiAuth.get(`financial-transactions/attachments/${id}/show`) as apiResponseType;

export const storeFinancialTransactionAttachment = (
  uuid: string, 
  formData: FormData
) => apiAuth.post(
  `financial-transactions/${uuid}/attachments/store`, 
  formData,
  { headers: { 'Content-Type': 'multipart/form-data' } }
) as apiResponseType;

export const deleteFinancialTransactionAttachment = (id: number | string) =>
  apiAuth.delete(`financial-transactions/attachments/${id}/destroy`) as apiResponseType;
